export default {
  init() {
    window.addEventListener("load",function(){
      
      var accordionItemToggle = document.querySelectorAll(".accordion .item .banner .toggle");
      accordionItemToggle.forEach(function(toggleButton) {
        toggleButton.addEventListener("click", function(){
          this.parentElement.parentElement.classList.toggle("toggled");
        });
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/capabilities.js